export const DEBT_INPUT_TEMPLATES_FETCH_ALL = 'DEBT_INPUT_TEMPLATES_FETCH_ALL';
export const DEBT_INPUT_TEMPLATES_ADD_ONE = 'DEBT_INPUT_TEMPLATES_ADD_ONE';
export const DEBT_INPUT_TEMPLATES_UPDATE_ONE = 'DEBT_INPUT_TEMPLATES_UPDATE_ONE';
export const DEBT_INPUT_TEMPLATES_DELETE_ONE = 'DEBT_INPUT_TEMPLATES_DELETE_ONE';
